import { faPlus } from "@fortawesome/pro-solid-svg-icons";

import { Icon } from "src/design-system/Icon";

type AddBlockPreviewProps = {
  onClick: () => void;
};

export const AddBlockPreview: React.FC<AddBlockPreviewProps> = ({
  onClick,
}) => (
  <button
    className="flex h-full w-full cursor-pointer items-center justify-center rounded-lg bg-gray-100 transition-colors"
    data-loc="add-block-preview"
    type="button"
    onClick={onClick}
  >
    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-indigo-500">
      <Icon icon={faPlus} size="md" variant="inverted" />
    </div>
  </button>
);
